import React from 'react';
import PropTypes from 'prop-types';
import clone from 'clone'

import {oeInterfaceManager} from '../../../react-oe/oe-interface';
import OEInterfaceAdapter from '../../../react-oe/oe-interface-adapter';
import CustomScrollbar, {CustomScrollbarTrackVisibility, CustomScrollbarProps} from '../../../lib/custom-scrollbar/custom-scrollbar';
import OEToolbox from '../../../lib/tools/oe-toolbox';
import OEResizeObserver from '../../../lib/components/oe-resize-observer';
import MediaQueryTool from '../../../lib/tools/media-query-tool';
import retardUpdate from '../../../lib/react/update-retarder';
import OEPresentationItem from './oe-presentation-item';
import OEPresentationSlideMagnification, {OEPresentationSlideMagnificationPlacement} from './oe-presentation-slide-magnification';

export default class OEPresentationSlideList extends React.PureComponent {

    constructor(props) {
        super(props);

        this.oe = oeInterfaceManager.getInterface(this.props.moduleId);

        this.shouldScrollToActualNext = false;

        this.onlyPreviewSlides = this.props.onlyPreviewSlides;

        this.presID = -2;
        this.slides = [];
        this.activePresID = -2;
        this.activeSlideID = -1;

        this.magnification = {slideID: -1, parentRect: null, itemRect: null};

        this.state = {
            uiEnabled: false,
            presID: -2,
            slides: [],
            activePresID: -2,
            activeSlideID: -1,
            magnification: clone(this.magnification)
        };

        this.itemRectRequest = {};

        this.updateLanguage = this.updateLanguage.bind(this);
        this.onUIControllerStateChanged = this.onUIControllerStateChanged.bind(this);
        this.onActivePresentationChanged = this.onActivePresentationChanged.bind(this);
        this.onActiveSlideChanged = this.onActiveSlideChanged.bind(this);
        this.onSlideSet = this.onSlideSet.bind(this);
        this.onSlideAdded = this.onSlideAdded.bind(this);
        this.onSlideRemoved = this.onSlideRemoved.bind(this);
        this.onSlideMoved = this.onSlideMoved.bind(this);
        this.onSlideDataChanged = this.onSlideDataChanged.bind(this);
        
        this.onRef = this.onRef.bind(this);
        this.onElementRef = this.onElementRef.bind(this);
        this.onScrollbarRef = this.onScrollbarRef.bind(this);

        this.onScroll = this.onScroll.bind(this);
        this.onResize = this.onResize.bind(this);
        this.onItemClicked = this.onItemClicked.bind(this);
        this.onItemMouseEnter = this.onItemMouseEnter.bind(this);
        this.onItemMouseLeave = this.onItemMouseLeave.bind(this);
    }

    setStateUpdate(spec)   {
        OEToolbox.updateComponentState(this, spec);
    }

    componentWillReceiveProps(nextProps) {
        if(nextProps.presID !== this.props.presID)     {
            this.updatePres(nextProps.presID, nextProps);
        }

        if(nextProps.onlyPreviewSlides !== this.props.onlyPreviewSlides)     {
            this.onlyPreviewSlides = nextProps.onlyPreviewSlides;
            this.updateSlidesInState();
        }
    }

    componentDidMount()    {
        this.componentDidUpdate();
    }

    componentDidUpdate()    {
        if(this.shouldScrollToActualNext === true)    {
            this.scrollToActual();
            this.shouldScrollToActualNext = false;
        }
    }

    onConnect()  {
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.languageChanged, this.updateLanguage);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.uiControllerStateChanged, this.onUIControllerStateChanged);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.activePresentationChanged, this.onActivePresentationChanged);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.activePresentationSlideChanged, this.onActiveSlideChanged);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.presentationSlideSet, this.onSlideSet);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.presentationSlideAdded, this.onSlideAdded);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.presentationSlideRemoved, this.onSlideRemoved);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.presentationSlideMoved, this.onSlideMoved);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.presentationSlideDataChanged, this.onSlideDataChanged);
    }

    onRelease()  {
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.languageChanged, this.updateLanguage);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.uiControllerStateChanged, this.onUIControllerStateChanged);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.activePresentationChanged, this.onActivePresentationChanged);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.activePresentationSlideChanged, this.onActiveSlideChanged);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.presentationSlideSet, this.onSlideSet);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.presentationSlideAdded, this.onSlideAdded);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.presentationSlideRemoved, this.onSlideRemoved);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.presentationSlideMoved, this.onSlideMoved);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.presentationSlideDataChanged, this.onSlideDataChanged);
    }

    updateLanguage()   {
        this.slides.forEach((slide) => { slide.name = slide.data.name.get(); slide.desc = slide.data.description.get(); });
        this.updateSlidesInState();
    }

    updateUIState()   {
        this.setState({ uiEnabled: this.oe.sharedInterface.getUIControllerPresentation().getUIEnabled() });
    }

    updatePres(id, props)  {
        props = props || this.props;
        let id_;

        if(typeof(id) === 'number') {
            id_ = id;
        } else if(typeof(props.presID) === 'number')   {
            id_ = props.presID;
        } else if(this.oe.isReady())    {
            id_ = this.oe.sharedInterface.getUIControllerPresentation().getActivePresentationID();
        }

        if(typeof(id_) === 'undefined' || this.presID === id_) return;

        this.presID = id_;
        this.setState({presID: id_});
        this.updateSlides();
    }

    updateSlides()   {
        this.slides = [];

        if(this.presID < 0 || !this.oe.isReady()) {
            this.setState({ slides: [] });
            return;
        }

        let presController = this.oe.sharedInterface.getUIControllerPresentation();
        let presentation = presController.getPresentationDataID(this.presID);

        if(!presentation)  {
            this.setState({ slides: [] });
            return;
        }

        let slides_ = presentation.slides;
        for(let i = 0; i < slides_.length; i++) {
            const slideID = slides_[i];
            const data = presController.getSlideDataID(this.presID, slideID);
            this.slides.push({id: slideID, data: data, name: data.name.get(), desc: data.description.get()});
        }

        this.updateSlidesInState();
        this.scrollToActualNext();
        this.resetMagnification();
    }

    updateSlidesInState()   {
        if(!this.onlyPreviewSlides) {
            this.setState({ slides: Array.from(this.slides) });
        } else {
            this.setState({ slides: this.slides.filter(slide => slide.data.showInPlayerPreview) })
        }
        this.updateActiveSlideInState();
    }

    updateActiveSlideInState()  {
        this.setState({activeSlideID: this.nearestSlidePreviewIDForID(this.activeSlideID)});
    }

    updateState(released)   {
        if(!this.oe.isReady() || released === true)   {
            this.presID = -2;
            this.slides = [];
            this.activePresID = -2;
            this.activeSlideID = -1;
            this.magnification.slideID = -1;
            this.setState({uiEnabled: false, presID: -2, slides: [], activePresID: -2, activeSlideID: -1, magnification: clone(this.magnification)});
            return;
        }

        retardUpdate(this, () => {
            this.updatePres();
            this.onActivePresentationChanged();
            this.updateLanguage();
            this.updateUIState();
        });
    }

    resetMagnification()    {
        this.magnification.slideID = -1;
        this.setState({magnification: clone(this.magnification)});
    }

    updateMagnification(id) {
        id = typeof(id) === 'number' ? id : -1;
        if(this.magnification.slideID === id)   {
            this.updateMagnificationRects();
            return;
        }
        this.magnification.slideID = id;
        this.setState({magnification: clone(this.magnification)});
        this.updateMagnificationRects();
    }

    updateMagnificationRects()  {
        let id = this.magnification.slideID;

        let magnification = clone(this.magnification);

        if(id >= 0) {
            let itemElement = this['item' + id.toString() + 'Element'];
            if(itemElement)    magnification.itemRect = OEToolbox.rectFromDOMRect(itemElement.getBoundingClientRect());
        }

        if(this.ref)    magnification.parentRect = OEToolbox.rectFromDOMRect(this.ref.getBoundingClientRect());

        if(OEToolbox.shallowEqual(this.magnification, magnification, true)) return;

        this.magnification = magnification;
        this.setState({magnification: clone(this.magnification)});
    }

    onUIControllerStateChanged(message, userInfo)    {
        if(userInfo.type !== this.oe.Module.UIControllerType.presentation)  return;
        this.updateUIState();
    }

    onActivePresentationChanged(message, userInfo)   {
        let activePresID = typeof(userInfo) === 'undefined' ? this.oe.sharedInterface.getUIControllerPresentation().getActivePresentationID() : userInfo.presID;

        if(typeof(this.props.presID) !== 'number' && this.presID !== activePresID)  {
            this.updatePres(activePresID);
        }

        if(activePresID !== this.activePresID)   {
            this.activePresID = activePresID;
            this.setState({activePresID: activePresID});
            this.props.onActivePresentationChanged(activePresID);
            this.onActiveSlideChanged();
            this.resetMagnification();
            this.scrollToActualNext();
        }
    }

    onActiveSlideChanged(message, userInfo)   {
        let activeSlideID = typeof(userInfo) === 'undefined' ? this.oe.sharedInterface.getUIControllerPresentation().getActiveSlideID() : userInfo.slideID;

        if(activeSlideID !== this.activeSlideID)   {
            this.activeSlideID = activeSlideID;
            this.updateActiveSlideInState();
            this.props.onActiveSlideChanged(activeSlideID);
            this.scrollToActualNext();
        }
    }

    onSlideSet(message, userInfo)   {
        if(this.presID !== userInfo.presID) return;

        let presController = this.oe.sharedInterface.getUIControllerPresentation();
        let data = presController.getSlideDataID(this.presID, userInfo.slideID);
        this.slides.splice(userInfo.slide, 1, {id: userInfo.slideID, data: data, name: data.name.get(), desc: data.description.get()});
        this.updateSlidesInState();
    }

    onSlideAdded(message, userInfo)  {
        if(this.presID !== userInfo.presID) return;

        let presController = this.oe.sharedInterface.getUIControllerPresentation();
        let data = presController.getSlideDataID(this.presID, userInfo.slideID);
        this.slides.splice(userInfo.slide, 0, {id: userInfo.slideID, data: data, name: data.name.get(), desc: data.description.get()});
        this.updateSlidesInState();

        this.scrollToActualNext();

        this.resetMagnification();
    }

    onSlideRemoved(message, userInfo)    {
        if(this.presID !== userInfo.presID)   return;

        this.slides.splice(userInfo.slide, 1);
        this.updateSlidesInState();

        this.scrollToActualNext();

        this.resetMagnification();
    }

    onSlideMoved(message, userInfo)  {
        let updated = false;
        if(this.presID === userInfo.presSrcID)   {
            this.slides.splice(userInfo.slideSrc, 1);
            updated = true;
        }

        if(this.presID === userInfo.presDstID)   {
            let presController = this.oe.sharedInterface.getUIControllerPresentation();
            let data = presController.getSlideDataID(this.presID, userInfo.slideDstID);
            this.slides.splice(userInfo.slideDst, 0, {id: userInfo.slideDstID, data: data, name: data.name.get(), desc: data.description.get()});
            updated = true;
        }

        if(updated) {
            this.updateSlidesInState();
            this.resetMagnification();
        }
    }

    onSlideDataChanged(message, userInfo)   {
        if(this.presID !== userInfo.presID) return;
        this.slides[userInfo.slide].data = userInfo.data;
        this.slides[userInfo.slide].name = userInfo.data.name.get();
        this.slides[userInfo.slide].desc = userInfo.data.description.get();
        this.updateSlidesInState();
    }

    slideIndexForID(id)   {
        if(id < 0)  return -1;
        for(let i = 0; i < this.slides.length; i++) {
            if(this.slides[i].id === id) return i;
        }
        return -1;
    }

    slidePreviewIndexForID(id) {
        if(!this.onlyPreviewSlides) return this.slideIndexForID(id);

        let count = 0;
        for(let i = 0; i < this.slides.length; i++) {
            const slide = this.slides[i];
            if(!slide.data.showInPlayerPreview) continue;
            if(slide.id === id) return count;
            count++;
        }
        return -1;
    }
    
    nearestSlidePreviewIDForID(id) {
        if(id < 0)  return -1;

        //
        let slideIndex = this.slideIndexForID(id);
        if(slideIndex < 0)  return -1;
        if(!this.onlyPreviewSlides) return id;

        //
        if(this.slides[slideIndex].data.showInPlayerPreview)  return id;

        //
        let lowerIndex = -1;
        for(let i = slideIndex - 1; i >= 0; i--)    {
            let slide = this.slides[i];
            if(slide.data.showInPlayerPreview)   {
                lowerIndex = i;
                break;
            }
        }

        //
        let higherIndex = -1;
        for(let i = slideIndex + 1; i < this.slides.length; i++)    {
            let slide = this.slides[i];
            if(slide.data.showInPlayerPreview)  {
                higherIndex = i;
                break;
            }
        }

        //
        let dis = -1, index = -1;
        if(lowerIndex >= 0) {
            dis = slideIndex - lowerIndex;
            index = lowerIndex;
        }

        if(higherIndex >= 0 && (dis < 0 || (higherIndex - slideIndex) < dis))   {
            index = higherIndex;
        }

        //
        if(index >= 0)  {
            return this.slides[index].id;
        }

        return -1;
    }

    nearestSlidePreviewIndexForID(id) {
        let previewId = this.nearestSlidePreviewIDForID(id);
        return this.slidePreviewIndexForID(previewId);
    }

    scrollTo(slideID)    {
        let id = this.nearestSlidePreviewIDForID(slideID);
        if(id < 0 || typeof(this.scrollbar) === 'undefined') return;

        let item = this['item' + id.toString() + 'Element'];
        if(!item) return;

        let itemCenter = item.offsetLeft + 0.5 * item.offsetWidth;
        let scrollViewCenter = 0.5*this.scrollbar.getClientWidth();
        let scrollLeft = itemCenter - scrollViewCenter;
        this.scrollbar.scrollLeft(scrollLeft);
    }

    scrollToActual()    {
        if(this.activeSlideID < 0 || this.presID !== this.activePresID) return;
        this.scrollTo(this.activeSlideID);
    }

    scrollToActualNext()    {
        this.shouldScrollToActualNext = true;
        this.forceUpdate();
    }

    itemRect(id, fn)  {
        if(id === null || typeof(id) !== 'number' || id < 0) return;
        let item = this['item' + id.toString() + 'Element'];
        if(!item) {
            if(fn) {
                let ar = this.itemRectRequest[id.toString()] || [];
                ar.push(fn);
                this.itemRectRequest[id.toString()] = ar;
            }
            return;
        }
        const res = {x: item.offsetLeft, y: item.offsetTop, width: item.offsetWidth, height: item.offsetHeight};
        if(fn) fn(res);
        return res;
    }

    slideIdForIndex(index)  {
        if(index >= 0 && index < this.slides.length) return this.slides[index].id;
    }

    isActivePresentation()  {
        return this.presID === this.activePresID;
    }

    onRef(ref) {
        this.ref = ref;
    }

    onElementRef(ref, id) {
        this['item' + id.toString() + 'Element'] = ref;
        if(this.itemRectRequest[id.toString()]) {
            const res = this.itemRect(id);
            this.itemRectRequest[id.toString()].forEach(fn => { fn(res); });
            delete this.itemRectRequest[id.toString()];
        }
    }

    onScrollbarRef(ref) {
        this.scrollbar = ref;
    }

    render() {
        let disabled = !((this.state.uiEnabled || this.props.overrideUIEnabled) && this.props.enabled);

        const slides = !this.state.slides ? null : this.state.slides.map((slide, index) =>
            <OEPresentationItem
                key={slide.id}
                className={this.props.itemClassName}
                moduleId={this.props.moduleId}
                disabled={disabled}
                selected={slide.id === this.state.activeSlideID && this.state.activePresID === this.state.presID}
                id={slide.id}
                presID={this.state.presID}
                slideID={slide.id}
                index={index}
                showIndex={this.props.showIndices}
                name={slide.name}
                desc={slide.desc}
                elementRef={this.onElementRef}
                renderContent={this.props.renderItemContent}
                onClick={this.onItemClicked}
                onMouseEnter={this.onItemMouseEnter}
                onMouseLeave={this.onItemMouseLeave}
            />
        );

        return (
            <React.Fragment>
                <OEInterfaceAdapter moduleId={this.props.moduleId} receiver={this}/>
                <div 
                    className={'presentation-slides-view ' + this.props.className} 
                    style={this.props.style}
                    ref={this.onRef}
                >
                    <OEResizeObserver onResize={this.onResize} />

                    {this.props.noScrollbar ? <ul>{slides}</ul> :
                        <CustomScrollbar
                            {...this.props.scrollbar}
                            onScroll={this.onScroll}
                            ref={this.onScrollbarRef}
                        >
                            <ul>{slides}</ul>
                        </CustomScrollbar>
                    }

                    <OEPresentationSlideMagnification
                        className={this.props.magnificationClassName}
                        moduleId={this.props.moduleId}
                        enabled={this.props.magnification > 1}
                        visible={true}
                        magnification={this.props.magnification}
                        placement={this.props.magnificationPlacement}
                        presID={this.state.presID}
                        slideID={this.state.magnification.slideID}
                        parentRect={this.state.magnification.parentRect}
                        itemRect={this.state.magnification.itemRect}
                    />
                </div>
            </React.Fragment>
        );
    }

    onResize(sender, size)  {
        this.updateMagnificationRects();
        if(this.props.onResize)  this.props.onResize(size);
    }

    onScroll(...args)  {
        this.updateMagnificationRects();
        if(this.props.scrollbar.onScroll) this.props.scrollbar.onScroll(...args);
    }

    onItemClicked(id)   {
        this.props.onItemClicked(id);   // call this in front of own handling for OEMediaCenterItemPres
        if(!this.oe.isReady())  return;

        let si = this.oe.sharedInterface;
        let controller = si.getUIControllerPresentation();

        //
        let needsActivePresChange = this.state.presID !== this.state.activePresID;
        if(needsActivePresChange) {
            controller.setActivePresentationID(this.state.presID);
        }

        //
        if(!needsActivePresChange && this.props.onlyPreviewSlides && controller.getAnimationMode() !== this.oe.Module.AnimationMode.play)    {
            let nextSlideID = controller.getNextSlideID(true, false);
            if(nextSlideID === id)  {
                controller.gotoNextSlide(true, false, true);
                return;
            }
            let prevSlideID = controller.getPrevSlideID(true, false);
            if(prevSlideID === id)  {
                controller.gotoPrevSlide(true, false, true);
                return;
            }
        }

        //
        controller.setActiveSlideID(id);
        controller.apply(true);
    }

    onItemMouseEnter(id, e)    {
        if(!(MediaQueryTool.hasPrimaryHover && MediaQueryTool.hasPrimaryFinePointer)) return;     // no magnification for devices without touch input
        this.updateMagnification(id);
    }

    onItemMouseLeave(id, e)    {
        this.resetMagnification();
    }
}

OEPresentationSlideList.defaultProps = {
    className:                          '',
    itemClassName:                      '',
    magnificationClassName:             '',
    moduleId:                           '',
    enabled:                            true,
    onlyPreviewSlides:                  false,
    magnification:                      1,
    magnificationPlacement:             OEPresentationSlideMagnificationPlacement.top,
    showIndices:                        false,
    scrollbar: {
        horizontalTrackVisiblity:       CustomScrollbarTrackVisibility.always,
        verticalTrackVisiblity:         CustomScrollbarTrackVisibility.none,
    },
    onItemClicked:                      (id) => {},
    onActivePresentationChanged:        (id) => {},
    onActiveSlideChanged:               (id) => {}
};

OEPresentationSlideList.propTypes = {
    className:                          PropTypes.string,
    itemClassName:                      PropTypes.string,
    magnificationClassName:             PropTypes.string,
    moduleId:                           PropTypes.string,
    enabled:                            PropTypes.bool,
    onlyPreviewSlides:                  PropTypes.bool,
    magnification:                      PropTypes.number,
    magnificationPlacement:             PropTypes.oneOf(OEPresentationSlideMagnificationPlacement.all),
    showIndices:                        PropTypes.bool,
    scrollbar:                          CustomScrollbarProps.propsDecl,
    onResize:                           PropTypes.func,
    onItemClicked:                      PropTypes.func,
    onActivePresentationChanged:        PropTypes.func,
    onActiveSlideChanged:               PropTypes.func
};